import { defineMessages, FormattedMessage } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { BodyText, IllusEmpty_1, TitleText } from '@garnish/core';
import { Image } from '@garnish/media';

export const NoResults = ({ message = '' }) => {
  return (
    <View style={styles.wrapper} testID="location-no-results">
      <Image source={IllusEmpty_1} style={styles.image} />

      <TitleText sizeMatch={['18', '24']} style={styles.title}>
        {message}
      </TitleText>

      <BodyText sizeMatch={['16', '18']}>
        <FormattedMessage {...messages.tryAnotherSearch} />
      </BodyText>
    </View>
  );
};

// ─── Messages ───────────────────────────────────────────────────────────────────

const messages = defineMessages({
  tryAnotherSearch: {
    defaultMessage: 'Try another search',
    description: 'Account | Address Form | No results | Try another search',
  },
});

// ─── Styles ───────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  wrapper: {
    alignItems: 'center',
    textAlign: 'center',
    paddingVertical: theme.spacing['10'],
    paddingHorizontal: theme.spacing['6'],
  },
  image: {
    width: 248,
    height: 248,
    resizeMode: 'contain',
  },
  title: {
    marginBottom: theme.spacing['4'],
  },
});
